import { reads } from '@ember/object/computed';
import Em from 'ember';
export default Em.Mixin.create({
  isCentered: reads('editableObject.isCentered'),
  actions: {
    toggleAlignment() {
      let alignment = 'center';
      if (this.get('isCentered')) {
        alignment = 'left';
      }
      this.set('editableObject.align', alignment);
      if (this.triggerDomUpdate) {
        this.triggerDomUpdate();
      }
    }
  }
});